module.exports = __webpack_public_path__ + "static/img/eicad_item6.69e7dc15.png";